import _ from 'underscore';
import TemplateView from 'picnic/core/views/Template';
import Template from 'app/cms/carpricechecker/views/appointmentsSelect/CheckAllLink.html';


class View extends TemplateView {

	constructor(options) {
		super(options);

		_.bindAll(
			this,
			'_onClick'
		);
	}

	get data() {
		return {
			title: this.options.title || this.el.getAttribute('data-title')
		};
	}

	get insertMethod() {
		return 'insertBefore';
	}

	get template() {
		return Template;
	}

	render() {
		super.render();

		this.content.on('click', this._onClick);

		return this;
	}

	toggleText(text) {
		this.content.text(text || this.content.attr('data-title'));
		this.content.attr('title', text || this.content.attr('data-title'));
	}

	_onClick(event) {
		event.preventDefault();

		this.trigger('click', {
			instance: this
		});
	}
}

export default View;
